import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";
import AFSPaymentConfirmation from "./afs.payment.confirmation";
import AFSPaymentWidget from "./afs-payment.widget";

const AfsPaymentContainer = ({
  paymentLinkInfo = {},
  fetchPaymentLinkInfo = () => {},
} = {}) => {
  const location = useLocation();
  const queryParams = queryString.parse(location.search);

  return (
    <>
      {queryParams.checkoutId ? (
        <AFSPaymentConfirmation
          paymentLinkInfo={paymentLinkInfo}
          fetchPaymentLinkInfo={fetchPaymentLinkInfo}
        />
      ) : (
        <AFSPaymentWidget
          paymentLinkInfo={paymentLinkInfo}
          fetchPaymentLinkInfo={fetchPaymentLinkInfo}
        />
      )}
    </>
  );
};

export default AfsPaymentContainer;
